import { Button, Card, Table } from "react-bootstrap"
import MediaFileInfo from "../../media/model/MediaFileInfo"
import FileDownloadLink from "../../media/components/FileDownloadLink"
import { useEffect, useState } from "react"
import notesApi from "../api/NotesApi"
import FileSize from "../../media/components/FileSize"
import { FormattedMessage } from "react-intl"

type Props = {
    noteId: number,
    editMode: boolean
}

const NoteFilesList = ({ noteId, editMode }: Props) => {

    const [files, setFiles] = useState<MediaFileInfo[]>([]);

    const getFilesList = () => {
        notesApi.getNoteFiles(noteId)
            .then(data => {
                console.log(data)
                setFiles(data);
            });
    }

    useEffect(() => {  
        if (noteId){
            notesApi.getNoteFiles(noteId)
                .then(data => {
                    setFiles(data);
                });
        }        
    }, [noteId])

    const deleteFile = (noteId:number, fileId: number) => {
        notesApi.deleteNotFile(noteId, fileId)
            .then(() => {
                if (noteId) {
                    getFilesList();
                }                    
            });
    }

    const uploadFile = (file:File) => {
        notesApi.uploadNoteFile(noteId, file)
            .then(() => {
                getFilesList()
            })
    }

    const getFileIcon = (file:MediaFileInfo) => {
        if(file.isImage()) {
            console.log("s")
            return <i className="fa-regular fa-image file-icon"></i>        
        }
        return <i className="fa-regular fa-file file-icon"></i>;
    }
    
    return (
        <div className="notes-file-list container">

            {!editMode ? "" : <input id="note-file" name="note-file" type="file" 
                    className="form-control" 
                    onChange={(event) => {
                        uploadFile(event.currentTarget.files![0]);
                }} />}

            {files.length === 0 ? "" : 
                <div className="row">
                    {files.map((file) => (
                        <div className="col-6 col-md-2" key={'file' + file.id}>
                            <Card>
                                {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
                                <Card.Body>
                                    <Card.Title>
                                        {getFileIcon(file)}
                                    </Card.Title>
                                    <Card.Text>
                                        <FileDownloadLink file={file}/>
                                    </Card.Text>
                                    
                                    {!editMode ? "" : 
                                        <div className="mt-2 text-center">
                                            <Button className="btn-color" onClick={() => deleteFile(noteId!, file.id!)}>
                                                <FormattedMessage id="delete"/>
                                            </Button>
                                        </div>
                                    }
                                </Card.Body>
                            </Card>   
                        </div>
                    ))}     
                </div>

                // <Table bordered hover size="sm">



                //     <tbody>
                //         {files.map((file) => (
                //             <tr key={file.id}>
                //                 <td></td>
                //                 <td><FileSize value={file.size}/></td>
                //                 {!editMode ? "" : <td>
                //                     <button type="button" onClick={() => deleteFile(noteId!, file.id!)}>Delete</button>
                //                 </td> }
                //             </tr>
                //         ))}
                //     </tbody>
                // </Table>
            }
        </div>
    )
}

export default NoteFilesList